import * as React from 'react';
import { Dialog, DialogContent } from 'shared';
import { Button, Typography } from '@SBGSports/referee-react';
import styles from './focus-import.module.css';
import { IconCancelSmall } from '@SBGSports/referee-react/icons';
import { useTranslations } from 'i18n';
import { useFocusStoredOptions } from './use-focus-stored-options';

interface BakingProcessDialogProps {
    open: boolean;
    onClose: (isOpen: boolean) => void;
}
export const BakingProcessDialog: React.FC<BakingProcessDialogProps> = (props) => {
    const { open, onClose } = props;
    //Hooks
    const { __ } = useTranslations();
    const { focusStoredOptions, setFocusStoredOptions } = useFocusStoredOptions();
    return (
        <Dialog
            data-testid="baking-process-dialog"
            fullWidth
            open={open}
            onClose={() => {
                onClose(false);
                setFocusStoredOptions({ ...focusStoredOptions, isBaking: false });
            }}
        >
            <div className={styles['dialog-title']}>
                <Typography variant="heading-2">{__('smt_importer.focus_import_has_begun')}</Typography>
                <Button
                    testId="baking-process-dialog-close-button"
                    onClick={() => {
                        onClose(false);
                        setFocusStoredOptions({ ...focusStoredOptions, isBaking: false });
                    }}
                    title="cancel"
                    variant="text"
                >
                    <IconCancelSmall />
                </Button>
            </div>
            <DialogContent>
                <div className={styles['dialog-body']}>
                    <Typography variant="body-1">{__('smt_importer.focus_import_begun_body')}</Typography>
                    <Typography variant="body-1">{__('smt_importer.focus_import_begun_footer')}</Typography>
                </div>
            </DialogContent>
        </Dialog>
    );
};
